// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbsWrapperUi__container__PY4DK","backLink":"BreadcrumbsWrapperUi__backLink__1MO6G"};